export const getSection = (pathname) => {
  let section

  if (pathname.includes('teacher')) section = 'admin'
    // else if (pathname.includes('manager')) section = 'manager'
    // else if (pathname.includes('inventory')) section = 'inventory'
    // else if (pathname.includes('doctor')) section = 'doctor'
    // else if (pathname.includes('therapist')) section = 'therapist'
  else if (pathname.includes('employee')) section = 'employee'
  else if (pathname.includes('patient')) section = 'patient'

  return section
}